import Tracker from '@openreplay/tracker';
let tracker = undefined;


const sanitizer = (data) => {
    if (data.url.includes("/login") || data.url.includes("/register") || data.url.includes("/reset-password")) {
        data.body = { ...data.body, password: "FILTERED" };
    }
    return data
}

const startSession = () => {
    if (!tracker) {
        tracker = new Tracker({
            projectKey: "6BV3PHrjOuNwsiuS666J",  
            network: {
                capturePayload: true, // Capture HTTP payload
                sanitizer: sanitizer
            }
        });
        tracker.start()
    }
    return tracker
}

const getTracker = () => {
    return tracker;
}


export {
    startSession,
    getTracker
}